import { LatLng, operation } from "@/commonJS/Actions/actionInterface";
import getData from "@/commonJS/getData";

export function calculateDistance(start: LatLng, end: LatLng): number {
  const p = 0.017453292519943295; // Math.PI / 180
  const a = 0.5 - 
    Math.cos((end.latitude - start.latitude) * p) / 2 + 
    Math.cos(start.latitude * p) * 
    Math.cos(end.latitude * p) * 
    (1 - Math.cos((end.longitude - start.longitude) * p)) / 2;
  
  return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
}

const performOperations = (data: any, operations: operation[], globalState: any, fullGlobalState?: any, reduxState?: any, collectionStateOrPayload?: any) => {
  let calculatedData = data;
  for (let i = 0; i < operations?.length; i++) {
    const currentOperation = operations[i];
    const dynamicValue = currentOperation?.value !== undefined ? (typeof currentOperation?.value === "string" ? Number(currentOperation?.value) : (currentOperation?.value?.source === "DEFAULT" && (!currentOperation?.value?.key || currentOperation?.value?.key?.length <= 0)) ? collectionStateOrPayload : Number(getData(currentOperation?.value,currentOperation?.value?.source === "GLOBAL" ? fullGlobalState : currentOperation?.value?.source === "REDUX" ? reduxState : currentOperation?.value?.source === "DEFAULT" ? collectionStateOrPayload : globalState))):undefined;
    switch (currentOperation?.type) {
      case "INCREMENT":
        calculatedData = Number((Number(calculatedData) ?? 0) + (dynamicValue ?? 0));
        break;
      case "MULTIPLY":
        calculatedData = Number((Number(calculatedData) ?? 0) * (dynamicValue ?? 0));
        break;
      case "DIVISION":
        calculatedData = Number((Number(calculatedData) ?? 0) / (dynamicValue ?? 0));
        break;
      case "DECREMENT":
        if(currentOperation.from === "R_TO_L"){
          calculatedData = Number((dynamicValue ?? 0) - (Number(calculatedData) ?? 0));
        }else{
          calculatedData = Number((Number(calculatedData) ?? 0) - (dynamicValue ?? 0));
        }
        break;
      case "ROUND":
        calculatedData = Math.round((dynamicValue !== undefined) ? dynamicValue : calculatedData)
        break;
      case "FIXED":
        calculatedData = (((dynamicValue !== undefined) ? dynamicValue : calculatedData) ?? 0).toFixed((currentOperation?.decimal??2))
        break;
      case "DIFFERENCE":
        calculatedData = (getData(currentOperation?.operandLeft?? {key:""}, calculatedData)??0) - (getData(currentOperation?.operandRight?? {key:""},calculatedData)??0)
        break;
      case "ObjectToKeysArray":
        return Object.keys(calculatedData??{});
      case "CALCULATE_DISTANCE":
        const pointA = currentOperation?.getPoinAStructure ? getData(currentOperation.getPoinAStructure, currentOperation?.getPoinAStructure?.source === "GLOBAL" ? fullGlobalState : currentOperation?.getPoinAStructure?.source === "DEFAULT" ? collectionStateOrPayload : currentOperation?.getPoinAStructure?.source === "REDUX" ? reduxState : calculatedData,globalState,fullGlobalState,reduxState,collectionStateOrPayload) : calculatedData;
        const pointB = currentOperation?.getPoinBStructure ? getData(currentOperation.getPoinBStructure, currentOperation?.getPoinBStructure?.source === "GLOBAL" ? globalState : currentOperation?.getPoinBStructure?.source === "DEFAULT" ? collectionStateOrPayload : currentOperation?.getPoinBStructure?.source === "REDUX" ? reduxState : calculatedData,globalState,fullGlobalState,reduxState,collectionStateOrPayload) : calculatedData;
        
        return (pointA?.latitude && pointA?.longitude) && (pointB?.latitude && pointB?.longitude) ? calculateDistance(pointA,pointB)?.toFixed(2) : null;
        break;
      case "SNAP_TO_VALID_QUANTITY":
        let snapOutput = 0;

        const snapLowerValidQuantity = Math.floor(calculatedData / dynamicValue) * dynamicValue;
        const snapUpperValidQuantity = Math.ceil(calculatedData / dynamicValue) * dynamicValue;

        if(snapLowerValidQuantity === snapUpperValidQuantity){
          return calculatedData;
        }

        if (snapUpperValidQuantity <= 100) {
          snapOutput = snapUpperValidQuantity
        } else if (snapLowerValidQuantity >= 0) {
          snapOutput = snapLowerValidQuantity
        }

        return snapOutput;
        break;
      case "INCREMENT_AND_SNAP_TO_VALID_QUANTITY":
        let incOutput = 0;

        const incLowerValidQuantity = Math.floor(calculatedData / dynamicValue) * dynamicValue;
        const incUpperValidQuantity = Math.ceil(calculatedData / dynamicValue) * dynamicValue;

        if(incLowerValidQuantity === incUpperValidQuantity){
          return calculatedData + dynamicValue <= 100 ? calculatedData + dynamicValue : calculatedData;
        }

        if (incUpperValidQuantity <= 100) {
          incOutput = incUpperValidQuantity
        } else if (incLowerValidQuantity >= 0) {
          incOutput = incLowerValidQuantity
        }

        return incOutput;
        break;
      case "DECREMENT_AND_SNAP_TO_VALID_QUANTITY":
        let decOutput = 0;

        const decLowerValidQuantity = Math.floor(calculatedData / dynamicValue) * dynamicValue;
        const decUpperValidQuantity = Math.ceil(calculatedData / dynamicValue) * dynamicValue;

        if(decLowerValidQuantity === decUpperValidQuantity){
          return calculatedData - dynamicValue >= 0 ? calculatedData - dynamicValue : calculatedData;
        }

        if (decLowerValidQuantity >= 0) {
          decOutput = decLowerValidQuantity;
        } else if (decUpperValidQuantity <= 100) {
          decOutput = decUpperValidQuantity;
        }

        return decOutput;
        break;
      default:
        break;
    }
  }
  return calculatedData;
}

export default performOperations;